module.exports = __webpack_public_path__ + "static/media/zero.46486e49.svg";